/* eslint-disable @typescript-eslint/no-explicit-any */
import log, { Logger } from 'loglevel';

/**
 * 创建 logger 实例
 */
export function createLogger({ enable = true }: {
  enable?: boolean
}): Logger {
  const logger = log.noConflict() as Logger;
  if (!enable) {
    logger.disableAll();
  } else {
    logger.enableAll();
  }
  return logger;
}

export const logIns = createLogger({});

/**
 * logger 方法
 */
export const logger = {
  debug: (...msg: any[]): void => {
    logIns.debug(...msg);
  },
  warn: (...msg: any[]): void => {
    logIns.warn(...msg);
    window.aegisIns.report(...msg);
  },
  error: (...msg: any[]): void => {
    logIns.error(...msg);
    window.aegisIns.report(...msg);
  },
  trace: (...msg: any[]): void => {
    logIns.trace(...msg);
    window.aegisIns.info(...msg);
  },
  log: (...msg: any[]): void => {
    logIns.log(...msg);
    window.aegisIns.info(...msg);
  },
  info: (...msg: any[]): void => {
    logIns.info(...msg);
    window.aegisIns.info(...msg);
  },
  /**
   * info all 给 aegis 全量上报
   * 大数据量请勿使用
   */
  infoAll: (...msg: any[]): void => {
    logIns.info(...msg);
    window.aegisIns.infoAll(...msg);
  },
};
